import { useEffect, useState } from "react";
import { getLicense } from "../../services/axios";
import { useHistory } from "react-router-dom";

export const License = (props) => {
  let [license, setLicense] = useState(null);

  let history = useHistory();
  let PID = props.match.params.id;

  useEffect(() => {
    const fetchProduct = async (PID) => {
      const result = await getLicense(PID);
      console.log("result", result);
      setLicense(result);
    };
    fetchProduct(PID);
  }, [PID]);

  function goBack() {
    history.push({
      pathname: `/campaign/${license.campaign}`,
    });
  }

  return (
    <div className="m-8">
      <div
        className="underline cursor-pointer text-deeppurple mb-10"
        onClick={() => goBack(license.campaign)}
      >
        Back to Campaign
      </div>
      {license && <div className="p-16">{JSON.stringify(license)}</div>}
    </div>
  );
};
